// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"bbf3a2e9","312":"080fb17d","457":"0e68fce2","640":"81893824"}[chunkId] + ".chunk.js";
};